import { UNIT_OPTIONS, CURRENCY_OPTIONS } from '../../shared/models/list';

export function getQualityIssueBatchQuantity(batch: AllQualityIssueBatch) {
	const unit = batch.quantityUnitTr
		// if the quantity unit is not managed then take the net weight unit (ton)
		? batch.quantityUnitTr in UNIT_OPTIONS
			? batch.quantityUnitTr
			: 'to'
		: 'to';
	const value = unit === batch.quantityUnitTr
		? batch.quantityValue
		: batch.receivedNetQuantityValue;
	return { value, unit };
}

export class AllQualityIssueBatch {
	id?: number | undefined;
	reference = '';
	quantityValue = 0;
	quantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '';
	claimedQuantityValue = 0;
	claimedQuantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '';
	soldTo = '';
	customerOrderNumber = '';
	customerOrderItemNumber = '';
	supplierOrderNumber = '';
	supplierOrderItemNumber = '';
	receivedOrderSupplierReference = '';
	receivedOrderSupplierItem = '';
	receivedInvoiceQuantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '';
	receivedInvoiceAmountUnitTr: keyof typeof CURRENCY_OPTIONS | '' = '';
	receivedNetQuantityValue = 0;
	creationBy = '';
	creationDate = '';
	modifBy = '';
	modifDate = '';
	sfcC = '';
	barcode = '';
	receiptDate = '';
}
